import React from 'react';
import PropTypes from 'prop-types';

const Cashgrams = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.4 2.85999C22.5709 2.9786 22.7054 3.14246 22.7884 3.33322C22.8715 3.52398 22.8997 3.73409 22.87 3.93999L20.29 20.4C20.265 20.5534 20.2074 20.6997 20.1212 20.8291C20.0349 20.9585 19.922 21.0679 19.79 21.15C19.6579 21.2346 19.5093 21.2899 19.3541 21.3123C19.1988 21.3348 19.0406 21.3237 18.89 21.28L11.14 19.09C10.8784 19.015 10.6539 18.8458 10.5098 18.6149C10.3657 18.384 10.3124 18.1079 10.36 17.84L10.57 16.7L9.19 17.79C9.05105 17.9001 8.88794 17.9756 8.71409 18.0104C8.54024 18.0452 8.36062 18.0382 8.19 17.99L1.91 16.16C1.70558 16.098 1.52362 15.9779 1.38634 15.8142C1.24906 15.6505 1.16241 15.4505 1.13696 15.2384C1.11151 15.0263 1.14836 14.8114 1.24302 14.6199C1.33768 14.4284 1.48604 14.2686 1.67 14.16L21.22 2.81999C21.4009 2.71611 21.6072 2.66481 21.8157 2.67188C22.0242 2.67894 22.2266 2.7441 22.4 2.85999ZM5 14.77L8.25 15.77L11.49 13.2C11.6676 13.0615 11.8829 12.9798 12.1077 12.9655C12.3324 12.9513 12.5563 13.0051 12.75 13.12C12.9444 13.2324 13.099 13.4025 13.1922 13.6069C13.2854 13.8112 13.3126 14.0395 13.27 14.26L12.71 17.26L18.29 18.84L20.29 5.88999L5 14.77Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

Cashgrams.propTypes = {
  fill: PropTypes.string,
};

export default Cashgrams;
